
import ChatMessage from "@/models/chat-message";

export default {
    name: "ChatSayRight",
    props: {
        say: {
            type: ChatMessage,
            default:function () {
                return new ChatMessage
            }
        },
    },
}
